@use "./constants.scss" as *;
@use "./enhancers/index.scss" as *;

[data-#{$html-prefix-scroll-navigator}] {
    height: 100%;
    width: 100%;
    position: relative;
    overflow-y: scroll;
    // overflowX hidden does not hide content, it is here to prevent
    // scrollbar to appear during resize / reflow.
    // the content is supposed taking 100% width and the scrollbar
    // is part of the content.
    overflow-x: hidden;
}

[data-#{$html-prefix-viewport}] {
    background-color: white;
    position: relative;
    height: 100%;
    width: 100%;
}

// Applied to the container the reader is mounted into. Kept as a class (rather
// than inline styles) so mount only adds the class and destroy fully reverts by
// removing it, leaving no residue on a reused container.
.#{$html-prefix}-reader {
    background-color: white;
    position: relative;
    overflow: hidden;
}